import { render } from "./LongTextColumn.vue?vue&type=template&id=5773a994"
import script from "./LongTextColumn.vue?vue&type=script&lang=js"
export * from "./LongTextColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__